const getForm = (state) => state.application.form;

const getCode = (state) => state.application.code;

const getApplying = (state) => state.application.applying;

const isInMaintenenceMode = (state) => state.application.vendorConfig.creditReportProvider === 'maintenance';

const isRocketAccountEnabled = (state) => state.application.vendorConfig.authenticationProvider === 'rocketAccount';

const isPromoBannerActive = (state) => {
    const staticPromoBanner = state.application.vendorConfig.staticPromoBanner;
    if (staticPromoBanner === 'none' || staticPromoBanner === '') {
        return false;
    }
    return staticPromoBanner;
};

const checkMaintenenceModePending = (state) => state.application.checkMaintenanceModePending;

export default {
    getForm,
    getCode,
    getApplying,
    isInMaintenenceMode,
    checkMaintenenceModePending,
    isRocketAccountEnabled,
    isPromoBannerActive
};
